import { z } from 'zod';

import { ForeclosureId, LosId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableForeclosure = z
  .object({
    id: ForeclosureId,
    loanId: LosId,

    referralDate: zodTemporalPlainDate,
    /** Date loan status changed out of foreclosure */
    endDate: zodTemporalInstant.optional(),

    // Denormalized from reportable events for the active foreclosure period
    /** Date the foreclosure sale was scheduled (from foreclosureSaleScheduled reportable event) */
    saleSetDate: zodTemporalPlainDate.optional(),

    createdAt: zodTemporalInstant,
  })
  .meta({ title: 'Foreclosure' });

export type ExportableForeclosure = z.infer<typeof ExportableForeclosure>;
